// extracted by mini-css-extract-plugin
export default {"buttonsGap":"tEk9TNmsJAIUkqH183VR","halfWidth":"RoeQune6Z01ET2TqDp1J"};